import { render, staticRenderFns } from "./tabson2.vue?vue&type=template&id=e7a0add6&"
import script from "./tabson2.vue?vue&type=script&lang=js&"
export * from "./tabson2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports